/**
 * @generated SignedSource<<fff6620443e44f75d2a496ab69d34493>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatebindcardauthreasonwithtimestampPayload",
    "kind": "LinkedField",
    "name": "updatebindcardauthreasonwithtimestamp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BindCardAuthReasonUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BindCardAuthReasonUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ccb9db52406b92e9b69e5b18db570f62",
    "id": null,
    "metadata": {},
    "name": "BindCardAuthReasonUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation BindCardAuthReasonUpdateMutation(\n  $input: UpdatebindcardauthreasonwithtimestampInput!\n) {\n  updatebindcardauthreasonwithtimestamp(input: $input) {\n    integer\n  }\n}\n"
  }
};
})();

node.hash = "ccbeca54f2859af0da1a50b6e01c9188";

module.exports = node;
